import { styled } from 'styled-system/jsx'

const StyledCardSurface = styled('div', {
  base: {
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 24px 60px -20px rgba(128, 84, 255, 0.18)',
    width: '100%',
  },
  variants: {
    padding: {
      tight: { padding: '20px' },
      standard: { padding: '32px' },
      loose: { padding: '40px 32px' },
    },
  },
  defaultVariants: {
    padding: 'standard',
  },
})

export { StyledCardSurface }
